/**
 * Formata `sumarizacao_filtros` da apuração para exibição no subtítulo.
 * @see api-relatorios-sumarizacao/.docs/sumarizacao/08-modelo-dados.md
 */

function asStringList(value) {
  if (!Array.isArray(value)) return [];
  return value
    .map((item) => String(item ?? "").trim())
    .filter(Boolean);
}

/**
 * @param {object|null|undefined} sumarizacaoFiltros
 * @returns {string[]}
 */
export function extrairTermosExclusao(sumarizacaoFiltros) {
  if (!sumarizacaoFiltros || typeof sumarizacaoFiltros !== "object") return [];
  const raw =
    sumarizacaoFiltros.termos_exclusao ??
    sumarizacaoFiltros.termosExclusao ??
  [];
  return asStringList(raw);
}

/**
 * @param {object|null|undefined} sumarizacaoFiltros
 * @returns {string[]}
 */
export function extrairCamposExclusao(sumarizacaoFiltros) {
  if (!sumarizacaoFiltros || typeof sumarizacaoFiltros !== "object") return [];
  const raw = sumarizacaoFiltros.campos ?? [];
  return asStringList(raw);
}

/**
 * @param {object|null|undefined} sumarizacaoFiltros
 * @returns {string} ex.: "ZERAMENTO, RESULTADO" ou "(nenhum)"
 */
export function formatarTermosExclusao(sumarizacaoFiltros) {
  const termos = extrairTermosExclusao(sumarizacaoFiltros);
  if (!termos.length) return "(nenhum)";
  return termos.join(", ");
}

/**
 * @param {object|null|undefined} sumarizacaoFiltros
 * @returns {string} ex.: "descricao_contabil" ou "(padrão)"
 */
export function formatarCamposExclusao(sumarizacaoFiltros) {
  const campos = extrairCamposExclusao(sumarizacaoFiltros);
  if (!campos.length) return "(padrão)";
  return campos.join(", ");
}

/**
 * Monta o subtítulo da página de detalhe (sem ID e sem agrupamento).
 * @param {object} ap — objeto `apuracao` da API
 * @param {{ formatarCnpj: Function, exibirCodRelatorio: Function, fmtMesAno: Function }} formatters
 */
export function montarSubtituloDetalhe(ap, { formatarCnpj, exibirCodRelatorio, fmtMesAno }) {
  const empresa = ap?.empresa || "—";
  const cnpj = formatarCnpj(ap?.cnpj);
  const tipo = exibirCodRelatorio(ap?.tipo);
  const periodo = `${fmtMesAno(ap?.periodoInicio)} – ${fmtMesAno(ap?.periodoFim)}`;
  const termos = formatarTermosExclusao(ap?.sumarizacaoFiltros);
  const campos = formatarCamposExclusao(ap?.sumarizacaoFiltros);

  return [
    `ID ${ap?.id ?? "—"}`,
    `CNPJ ${cnpj}`,
    empresa,
    `Tipo: ${tipo}`,
    `Período: ${periodo}`,
    `Termos de exclusão: ${termos}`,
    `Campos: ${campos}`,
  ].join(" · ");
}
